export default __webpack_public_path__ + "static/media/background.4f0a5d7d.jpg";